import { PolygonClippedGridSystem, extentFromPolygon, } from '@zwaarcontrast/ol-graticule';
import { ProjectedGridSystem, registerCRS, } from '@zwaarcontrast/ol-graticule-projected';
import { OS_YARD_GRID_CRS, OS_YARD_GRID_PROJ4, OS_YARD_GRID_VALIDITY, OS_YARD_GRID_VALIDITY_WGS84, } from './yardGrid.js';
import { YardFormatter } from './YardFormatter.js';
const EXTENT_MARGIN_YD = 100_000;
/** The OS yard grid, clipped to the Quarter-inch Fourth Edition sheet faces. */
export function createOSYardGridSystem(options) {
    registerCRS(OS_YARD_GRID_CRS, OS_YARD_GRID_PROJ4);
    return new PolygonClippedGridSystem({
        source: new ProjectedGridSystem({
            formatter: new YardFormatter(),
            ...options,
            crs: OS_YARD_GRID_CRS,
            extent: extentFromPolygon(OS_YARD_GRID_VALIDITY, EXTENT_MARGIN_YD),
        }),
        clipPolygon: { rings: [OS_YARD_GRID_VALIDITY], crs: OS_YARD_GRID_CRS },
    });
}
/** Every OS grid, keyed by CRS. */
export const OS_GRIDS = {
    [OS_YARD_GRID_CRS]: {
        crs: OS_YARD_GRID_CRS,
        name: 'OS yard grid',
        proj4: OS_YARD_GRID_PROJ4,
        createGridSystem: () => createOSYardGridSystem(),
        validityWgs84: [OS_YARD_GRID_VALIDITY_WGS84],
    },
};
//# sourceMappingURL=grids.js.map